'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _product = require('./product.component');

var _product2 = _interopRequireDefault(_product);

var _copy = require('./copy/copy.module');

var _copy2 = _interopRequireDefault(_copy);

var _information = require('./information/information.module');

var _information2 = _interopRequireDefault(_information);

var _loadingAdminForm = require('./loading-admin-form/loading-admin-form.module');

var _loadingAdminForm2 = _interopRequireDefault(_loadingAdminForm);

var _loadingAdminList = require('./loading-admin-list/loading-admin-list.module');

var _loadingAdminList2 = _interopRequireDefault(_loadingAdminList);

var _maintenanceAdminForm = require('./maintenance-admin-form/maintenance-admin-form.module');

var _maintenanceAdminForm2 = _interopRequireDefault(_maintenanceAdminForm);

var _maintenanceAdminList = require('./maintenance-admin-list/maintenance-admin-list.module');

var _maintenanceAdminList2 = _interopRequireDefault(_maintenanceAdminList);

var _ingredientForm = require('./ingredient-form/ingredient-form.module');

var _ingredientForm2 = _interopRequireDefault(_ingredientForm);

var _ingredientList = require('./ingredient-list/ingredient-list.module');

var _ingredientList2 = _interopRequireDefault(_ingredientList);

var _signOff = require('./sign-off/sign-off.module');

var _signOff2 = _interopRequireDefault(_signOff);

var _usageData = require('./usage-data/usage-data.module');

var _usageData2 = _interopRequireDefault(_usageData);

require('./product.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product', [_angularUiRouter2.default, _copy2.default, _information2.default, _loadingAdminForm2.default, _loadingAdminList2.default, _maintenanceAdminForm2.default, _maintenanceAdminList2.default, _ingredientForm2.default, _ingredientList2.default, _signOff2.default, _usageData2.default]).component('product', _product2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('productEdit', {
    parent: 'app',
    url: '/products/{id:int}',
    component: 'product',
    resolve: {
      product: function product($stateParams, ProductService) {
        return ProductService.getProduct($stateParams.id).then(function (r) {
          return r.data;
        });
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      // TODO: Refactor to OData call
      categories: function categories(ProductService) {
        return ProductService.getCategories().then(function (r) {
          return r.data;
        });
      },
      frequencies: function frequencies(ProductService) {
        return ProductService.getFrequencies().then(function (r) {
          return r.data.map(function (f) {
            var obj = {};
            obj.Name = f.Name;
            obj.Value = +f.Value;
            return obj;
          });
        });
      },
      administrationUnits: function administrationUnits(ProductService) {
        return ProductService.getAdministrationUnitsForSupplements().then(function (r) {
          return r.data;
        });
      },
      weightUnits: function weightUnits(ProductService) {
        return ProductService.getWeightUnits().then(function (r) {
          return r.data;
        });
      }
    }
  }).state('productCreate', {
    parent: 'app',
    url: '/products/create',
    component: 'product',
    resolve: {
      product: function product(currentUser) {
        return {
          ProductId: 0,
          MemberId: currentUser.MemberId
        };
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      // TODO: Refactor to OData call
      categories: function categories(ProductService) {
        return ProductService.getCategories().then(function (r) {
          return r.data;
        });
      },
      frequencies: function frequencies(ProductService) {
        return ProductService.getFrequencies().then(function (r) {
          return r.data.map(function (f) {
            var obj = {};
            obj.Name = f.Name;
            obj.Value = +f.Value;
            return obj;
          });
        });
      },
      administrationUnits: function administrationUnits(ProductService) {
        return ProductService.getAdministrationUnitsForSupplements().then(function (r) {
          return r.data;
        });
      },
      weightUnits: function weightUnits(ProductService) {
        return ProductService.getWeightUnits().then(function (r) {
          return r.data;
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/product/product.module.js